export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-6">
          <span className="text-gray-500 text-sm font-semibold">About CAISA S.R.L.</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/9dd1b84e02a6be526d47715d95087017.jpg"
                alt="CAISA Technology"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="md:col-span-3">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              Protecting Your<br />
              Digital Privacy
            </h2>
            
            <div className="space-y-6 text-gray-600 text-lg leading-relaxed">
              <p>
                CAISA S.R.L. is a leading technology company based in Argentina, dedicated to developing innovative applications that enhance digital security and privacy. Our flagship VPN service represents years of research and development in cybersecurity technology.
              </p>
              
              <p>
                Founded with a mission to make the internet a safer place for everyone, we believe that online privacy is a fundamental right. Our team of security experts and developers work tirelessly to provide cutting-edge VPN technology that is both powerful and easy to use.
              </p>
              
              <p>
                Located in Garupá, Argentina, we serve customers worldwide with our commitment to transparency, security, and user privacy. We never compromise on the quality of our service or the protection of your data.
              </p>

              <p>
                At CAISA, we understand that trust is earned through consistent performance and unwavering dedication to our users' security. That's why we've built our VPN service with military-grade encryption, a strict zero-logs policy, and a global network of high-speed servers.
              </p>
            </div>

            <div className="mt-8">
              <a href="#contact" className="inline-flex items-center gap-2 text-teal-600 font-semibold text-lg hover:text-teal-700 transition-colors group">
                Read Our Story
                <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}